import React from "react";
import AddIcon from "@mui/icons-material/Add";
import { Button, SxProps, Typography } from "@mui/material";

interface IProps {
  title: string;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

export default function AddFlightBtn(props: IProps) {
  const { title, onClick = () => {} } = props;

  return (
    <Typography variant="h6" sx={sxStyles.iconButton}>
      {title}
      <Button
        sx={sxStyles.button}
        variant="contained"
        color="primary"
        disableElevation={true}
        onClick={onClick}
      >
        <AddIcon fontSize="small" />
      </Button>
    </Typography>
  );
}

const sxStyles: { [key: string]: SxProps } = {
  iconButton: {
    textAlign: { xs: "right", md: "left" },
    my: 3.375,
    mx: 0,
  },
  button: {
    ml: 1.25,
    minWidth: 0,
    p: 1,
    zIndex: 1,
  },
};
